import {saveState} from './localStorage';

export function saveAccountDetails(account) {
    //we don't want to persist the soundCloud token
    saveState({
        account: {
            //user: account.user,
            token: account.token,
            tokenExpiry: account.tokenExpiry,
            activeProfileID: account.activeProfileID
        }
    });
}